import React, { isValidElement, useMemo, } from 'react';
import styled from 'styled-components';
let FormattedMessage = null;
try {
    // eslint-disable-next-line max-len
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-var-requires
    FormattedMessage = require('react-intl').FormattedMessage;
}
catch (e) {
    if (!(e instanceof Error) || !~e.message.indexOf('Cannot find')) {
        throw e;
    }
}
export const useWrapTextChildren = (children) => {
    return useMemo(() => React.Children.toArray(children).map((child, idx) => {
        const isFormattedMessage = isValidElement(child) && child.type === FormattedMessage;
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return typeof child === 'string' || isFormattedMessage ? (React.createElement(TextWrap, { key: `${child}-${idx}` }, child)) : (child);
    }), [children]);
};
export const WrapTextChildren = ({ children }) => (React.createElement(React.Fragment, null, useWrapTextChildren(children)));
export const withTextWrap = (WrappedComponent) => 
// eslint-disable-next-line react/display-name
(props) => (React.createElement(TextWrap, null,
    React.createElement(WrappedComponent, { ...props })));
export const TextWrap = styled.span ``;
//# sourceMappingURL=textWrap.js.map